module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "lightGalleryTest",
      "id": "lightgallery"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/img/HOME/8496636515_ca9ef2a464_o.jpg"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/HOME/8496636515_ca9ef2a464_o.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/img/HOME/7899651992_b09e5c1244_o.jpg"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/HOME/7899651992_b09e5c1244_o.jpg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c47079a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vueLightGalleryTest/components/index.vue
// module id = 579
// module chunks = 2